<template>
  <div id="dashboard">
    <main-layout>
      <v-layout wrap>
        <v-flex sm1 shrink class="text-xs-right">
          <v-btn v-if="!showAllMenu" color="primary" icon outline @click="setShowAllMenu"
            ><i class="fa fa-th" aria-hidden="true"></i
          ></v-btn>
        </v-flex>
        <v-flex sm11>
          <v-tabs
            v-if="!showAllMenu"
            v-model="currentView"
            color="white"
            :slider-color="$vuetify.theme.primary"
            show-arrows
          >
            <!-- Neo Money -->
            <template
              v-if="
                selectedBot &&
                  ['2428337527228612', '106728661059512'].includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
            >
              <v-tab ripple :key="'neo-money-user-summary'" :href="'#neo-money-user-summary'">
                {{ $t('User Summary') }}
              </v-tab>
            </template>

            <!-- New dashboard -->
            <template>
              <v-tab ripple :key="'overview'" :href="'#overview'">
                {{ $t('Overview') }}
              </v-tab>
              <!-- <v-tab ripple :key="'active-user-graph'" :href="'#active-user-graph'">
                {{ $t('Metrics') }}
              </v-tab> -->
              <v-tab ripple :key="'inbox'" :href="'#inbox'">
                {{ $t('Conversation') }}
              </v-tab>
              <!-- <v-tab ripple :key="'inbox'" :href="'#inbox'">
            {{ $t('Inbox') }}
          </v-tab> -->
              <v-tab
                ripple
                :key="'comment'"
                :href="'#comment'"
                v-if="selectedBot && selectedBot.packages.includes('facebook')"
              >
                {{ $t('Comment') }}
              </v-tab>

              <v-tab ripple :key="'users'" :href="'#users'">
                {{ $t('users') }}
              </v-tab>
            </template>

            <!-- <v-tab v-if="isBU" ripple :key="'customers'" :href="'#customers'">
          {{ $t('Customer') }}
        </v-tab> -->

            <v-tab
              v-if="isRussianRoulette"
              ripple
              :key="'RussianRouletteDashboard'"
              :href="'#RussianRouletteDashboard'"
              >{{ $t('Admin performance') }}</v-tab
            >

            <v-tab v-if="isBU" ripple :key="'inbox-stat-register'" :href="'#inbox-stat-register'">
              {{ $t('Register') }}
            </v-tab>
            <v-tab v-if="isBU" ripple :key="'inbox-stat-faculty'" :href="'#inbox-stat-faculty'">
              {{ $t('Faculty') }}
            </v-tab>
            <v-tab
              v-if="isBU"
              ripple
              :key="'inbox-stat-scholarships'"
              :href="'#inbox-stat-scholarships'"
              >{{ $t('Scholarships') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-dashboard'"
              :href="'#aston-dashboard'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Aston') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-line-dashboard'"
              :href="'#aston-line-dashboard'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('AstonLine') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-outsource-dashboard'"
              :href="'#aston-outsource-dashboard'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Outsource') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-dashboard-admin-message'"
              :href="'#aston-dashboard-admin-message'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Admin message') }}</v-tab
            >
            <v-tab
              ripple
              :key="'AstonConversationRate'"
              :href="'#AstonConversationRate'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Conversation Rate') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-dashboard-admin-timing'"
              :href="'#aston-dashboard-admin-timing'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('AdminTiming') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-dashboard-feedback'"
              :href="'#aston-dashboard-feedback'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Feedback') }}</v-tab
            >
            <v-tab
              ripple
              :key="'aston-admin'"
              :href="'#aston-admin'"
              v-if="
                selectedBot &&
                  astonpages.includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('Admin') }}</v-tab
            >
            <v-tab
              ripple
              :key="'branch-location'"
              :href="'#branch-location'"
              v-if="
                selectedBot &&
                  ['102236091673671', '157480584306735', '115013341582884'].includes(selectedBot.pageid) &&
                  $store.getters.getPackage == 'premium'
              "
              >{{ $t('การจัดการสาขา') }}</v-tab
            >
            <v-tab
              ripple
              :key="'superten-dashboard'"
              :href="'#superten-dashboard'"
              v-if="selectedBot && $store.state.supertenpage.includes(selectedBot.pageid)"
              >{{ $t('Vote') }}</v-tab
            >

            <v-tab ripple :key="'tags-and-status'" :href="'#tags-and-status'">{{
              $t('Tags/Status')
            }}</v-tab>

            <v-tab ripple :key="'button-click'" :href="'#button-click'">
              {{ $t('url_tracking') }}
            </v-tab>
            <v-premium-lock
              style="margin-top: 5px; margin-left: -6px;"
              :inline="true"
            />

            <v-tab ripple :key="'product-analytics'" href="#product-analytics">{{
              $t('Sales Report')
            }}</v-tab>
            <v-premium-lock
                style="margin-top: 5px; margin-left: -6px;"
                :inline="true"
              >
            </v-premium-lock>
          </v-tabs>
        </v-flex>
      </v-layout>
      <template
        v-if="
          selectedBot &&
            $store.state.supertenpage.includes(selectedBot.pageid) &&
            currentView == 'customers'
        "
      >
        <component :is="'SupertenCustomer'"></component>
      </template>
      <template v-else>
        <component :is="currentView"></component>
      </template>
      <v-container v-if="showAllMenu">
        <h1 class="mb-3 mt-1">{{ $t('Analytics') }}</h1>
        <v-layout row wrap>
          <template v-for="(menu, i) in menuTab">
            <template v-if="menu.page.length === 0 || menu.page.includes(selectedBot.pageid)">
              <v-flex
                xs4
                sm3
                md2
                lg2
                style="padding: 2%"
                :key="i"
                v-if="menu.tab !== 'ProductAnalytics' || showProductAnalytic"
              >
                <v-hover
                  style="cursor: pointer"
                  v-if="menu.isPremiumLock.includes($store.getters.getPackage)"
                >
                  <v-card
                    slot-scope="{ hover }"
                    @click="setTabMenu(menu.tab)"
                    :class="`elevation-${hover ? 12 : 2}`"
                    style="height: 100%"
                    class="text-xs-center"
                  >
                    <v-img
                      aspect-ratio="1"
                      :src="`/static/img/assets/analytics-menu/${menu.image}`"
                      class="white--text align-end"
                    >
                    </v-img>

                    <v-card-actions class="primary--text" style="justify-content: center">
                      <span>{{ menu.name }}</span>
                    </v-card-actions>
                  </v-card>
                </v-hover>
                <div v-else>
                  <v-card
                    :class="`elevation-${hover ? 12 : 2}`"
                    style="height: 100%"
                    class="text-xs-center"
                  >
                    <v-img
                      style="opacity: 0.5"
                      aspect-ratio="1"
                      :src="`/static/img/assets/analytics-menu/${menu.image}`"
                      class="white--text align-end"
                    >
                    </v-img>
                    <v-btn
                      v-if="!$vuetify.breakpoint.xs"
                      @click="setTabMenu(menu.tab)"
                      color="primary"
                      style="margin: auto; position: absolute; top: 10px; left: 15px"
                      >ดูตัวอย่าง
                    </v-btn>
                    <v-premium-lock></v-premium-lock>
                    <v-card-actions
                      class="primary--text"
                      style="justify-content: center; opacity: 0.5"
                    >
                      <span>{{ menu.name }}</span>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'

import StatSummary from './StatSummary.vue'
import ActiveUserGraph from './ActiveUserGraph.vue'
import Customers from './Customers.vue'
import SummaryIntent from './SummaryIntent.vue'
import InboxStatRegister from './InboxStatRegister.vue'
import InboxStatFaculty from './InboxStatFaculty.vue'
import InboxStatScholarships from './InboxStatScholarships.vue'
import AstonDashboard from './AstonDashboard.vue'
import AstonLineDashboard from './AstonLineDashboard.vue'
import AstonOutsourceDashboard from './AstonOutsourceDashboard.vue'
import AstonDashboardAdminMessage from './AstonDashboardAdminMessage.vue'
import AstonDashboardAdminTiming from './AstonDashboardAdminTiming.vue'
import AstonDashboardFeedback from './AstonDashboardFeedback.vue'
import RussianRouletteDashboard from './RussianRouletteDashboard.vue'
import AstonConversationRate from './AstonConversationRate.vue'
import NeoMoneyUserSummary from './NeoMoneyUserSummary.vue'
import BranchLocation from './BranchLocation.vue'
import SupertenDashboard from './SupertenDashboard.vue'
import AstonAdmin from './AstonAdmin.vue'
import SupertenCustomer from './SupertenCustomer.vue'
import ButtonClick from './ButtonClick'

// New dashboard
import Overview from './Overview.vue'
import Inbox from './Inbox.vue'
import Comment from './Comment.vue'
import Users from './Users.vue'
import TagsAndStatus from './TagsAndStatus.vue'
import ProductAnalytics from '../template/ecommerce/ProductAnalytics.vue'
export default {
  data: function() {
    return {
      showIntent: false,
      currentView: null,
      showAllMenu: true,
      menuTab: [
        {
          name: this.$t('Overview'),
          tab: 'overview',
          image: 'icon_analytics_dashboard.png',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Conversation'),
          tab: 'inbox',
          image: 'icon_analytics_conversation.png',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Comment'),
          tab: 'comment',
          image: 'icon_analytics_comment.jpg',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('users'),
          tab: 'users',
          image: 'icon_analytics_customer.png',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Tags/Status'),
          tab: 'tags-and-status',
          image: 'icon_analytics_tags.jpg',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('url_tracking'),
          tab: 'button-click',
          image: 'icon_analytics_button_click.png',
          isPremiumLock: ['premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Sales Report'),
          tab: 'product-analytics',
          image: 'icon_analytics_Sales_Report.jpg',
          isPremiumLock: [ 'premium', 'advanced'],
          page: []
        },
        {
          name: 'การจัดการสาขา',
          tab: 'branch-location',
          image: 'icon_analytics_branch_location.jpg',
          isPremiumLock: [ 'premium'],
          page: ['102236091673671', '157480584306735', '115013341582884']
        },
      ]
    }
  },
  components: {
    StatSummary,
    AstonDashboard,
    AstonLineDashboard,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    InboxStatRegister,
    InboxStatFaculty,
    AstonOutsourceDashboard,
    InboxStatScholarships,
    AstonDashboardAdminMessage,
    AstonDashboardAdminTiming,
    AstonDashboardFeedback,
    RussianRouletteDashboard,
    NeoMoneyUserSummary,
    AstonConversationRate,
    BranchLocation,
    SupertenDashboard,
    AstonAdmin,
    SupertenCustomer,
    Overview,
    Inbox,
    Comment,
    Users,
    TagsAndStatus,
    ProductAnalytics,
    ButtonClick
  },
  created: function() {
    if (
      window.location.href.includes('enterprise.zwiz.ai')
    ) {
      this.$router.push('/' + this.currentLang + '/dashboard').catch(() => {})
    }
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'statistic':
      //   case 'crm':
      //   case 'custom_analytic':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'statistic'
      //     break
      // }
      vm.showAllMenu = false
      vm.currentView = vm.$route.query.tab
    }
  },
  mounted: function() {},
  computed: {
    astonpages() {
      return this.$aston.astonpages
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isRussianRoulette() {
      return this.$store.state.pageRussianRoulette.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    setShowAllMenu() {
      if (this.$route.query.tab) {
        this.$router.push(this.$route.path).catch(() => {})
      }
      this.currentView = null
      this.showAllMenu = true
    },
    setTabMenu(name) {
      this.currentView = name
      this.showAllMenu = false
    },
    updateRoute: function() {
      this.$router
        .push({
          name: 'analytics',
          path: '/analytics',
          query: {
            tab: this.currentView
          }
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/analytics/Dashboard.vue